import React from 'react';

/** What's New — a news page with a spark. Same stroke weight and active tan
 *  as the IP Intel / Ocean / Cosmos nav icons. */
export const WhatsNewIcon = ({ active }: { active: boolean }) => {
  const c = active ? '#9A7A4C' : 'currentColor';
  return (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M13 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 10h5M8 13.5h8M8 17h6" stroke={c} strokeWidth="1.6" strokeLinecap="round" opacity="0.75" />
      <path d="M18 2.5l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9z" stroke={c} strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  );
};
